import UserContractCreate from '../../pages/Commercial/UserContracts/Create'
import Route from '../Route'
import { CustomSwitch } from '../../components/CustomSwitch'

export const UserContractsRouter = (): JSX.Element => (
  <CustomSwitch>
    <Route path="/contract/:institution" component={UserContractCreate} exact />
  </CustomSwitch>
)
